export default __webpack_public_path__ + "static/media/dacsa_blanco_transparente.38b7ccf8.png";